import PerformanceStats from '@com-pc/performance-stats/index';
import CommonTips from '@com/common-tips/index';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import i18n from '@i18next/i18n';
import {
    masterDisabledItem,
    usedLayoutDisabledItem,
} from '@src/framework/editor/src/js/constants/right-menu-data';
import {
    CollaboratorSelectDisableItems,
    CommentDisableItems,
    LockDisableItems,
    NoPasteMemoryCacheDisableItems,
    NoRedoDisableItems,
    notOwnerDisableItems,
    NoUndoDisableItems,
    TwoElementDistributeDisableItems,
    ViewerDisableItems,
    ViewerEnableItems,
} from '@src/framework/editor/src/js/constants/top-menu-data';
import ArkLoader from '@src/js/common/ark-extensions';
import { getDownloadExtension } from '@src/js/common/ark-extensions/dc-components/docs-component-download';
import { EXPORT_PREFERENCE_DIALOG_EXTENSION } from '@src/js/common/ark-extensions/dc-components/export-preference-dialog';
import { isLicenseValid } from '@src/js/common/getPrivilegeAttr';
import { PropertyEditorShowAction } from '@src/js/constant';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';
import { IAddonHandler } from '@src/slide/application/service/addon/addon-handler.interface';
import { AddonManagerEventsKeys } from '@src/slide/application/service/addon/addon-manager.interface';
import ExportImageManager, { ICustomOptionsProps } from '@src/slide/application/service/export-image-manager/index';
import { IExportPreferenceService } from '@src/slide/application/service/export-preference-service/core/export-preference-service.interface';
import { IGridLineManager } from '@src/slide/application/service/grid-line-manager/index.interface';
import { IGuidesManager } from '@src/slide/application/service/guides-manager/index.interface';
import { IHistoryManager } from '@src/slide/application/service/history-manager/core/history-manager.interface';
import { IImportOnlineFileManager } from '@src/slide/application/service/import-file-manager/core/import-file-manager.interface';
import { IInsertTableRowColManager } from '@src/slide/application/service/insert-table-row-col-manager/index.interface';
import { IMasterLayoutEditService } from '@src/slide/application/service/master-layout-edit-service/master-layout-edit-service.interface';
import { handleCommonMenuEvent, handleModelMenuEvent } from '@src/slide/application/service/menu-manager/menu-event';
import { getDisableMenuItems, getMenuItems } from '@src/slide/application/service/menu-manager/menu-items';
import { MenuManagerEventsKeys, MenuManagerEventsMap } from '@src/slide/application/service/menu-manager/menu-manager-events.interface';
import { ExportPDFOptions, IMenuItems, IMenuManager } from '@src/slide/application/service/menu-manager/menu-manager.interface';
import { getMenuValues } from '@src/slide/application/service/menu-manager/menu-values';
import { IParagraphManager } from '@src/slide/application/service/paragraph-manager/core/paragraph-manager.interface';
import { IRightSideBarManager } from '@src/slide/application/service/right-side-bar-manager/right-side-bar-manager.interface';
import { ISectionManager } from '@src/slide/application/service/section-manager/section-manager.interface';
import SelectedEleManager from '@src/slide/application/service/selection/selected-ele-manager';
import {
    ISelectionService,
    SelectedModelType,
} from '@src/slide/application/service/selection/selection-service.interface';
import { ISnapLineService } from '@src/slide/application/service/snap-line-service/interface/snap-line-service.interface';
import { ITextRulerManager } from '@src/slide/application/service/text-ruler-manager/core/index.interface';
import { IThemeColorManager } from '@src/slide/application/service/theme-color-manager/index.interface';
import { IUserPriviledgeService } from '@src/slide/application/service/user-priviledge-service/user-priviledge-service.interface';
import { IFontManager } from '@src/slide/content-viewer/service/font-manager/core/font-manager.interface';
import { RegionType } from '@src/slide/domain/selection/constant/region';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { OnlineEditServices } from '@src/slide/domain/slide-app/scenes/online/core/online-edit-services.core';
import { PPTEditorStateType } from '@src/slide/domain/ui-model/constant/edit-state-type';
import { MenuType } from '@src/slide/domain/ui-model/constant/menu';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import GapModel from '@src/slide/domain/ui-model/element-modeles/gap-model';
import GroupModel from '@src/slide/domain/ui-model/element-modeles/group-model';
import {
    ModelMenuRefreshEventsKeys,
} from '@src/slide/domain/ui-model/element-modeles/Interface/model-menu-refresh.interface';
import { IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';
import MultiplyModel from '@src/slide/domain/ui-model/element-modeles/multiply-model';
import isElementsCanGroup, {
    canUnGroup,
} from '@src/slide/domain/ui-model/element-modeles/property/group-operation/group-condition';
import SectionModel from '@src/slide/domain/ui-model/element-modeles/section-model';
import { IUiDataService } from '@src/slide/domain/ui-model/service/ui-data-service.interface';
import { IS_ENTERPRISE } from '@src/slide/infrastructure/module/dependent/config/tob/constant';
import { imageToBase64 } from '@src/slide/infrastructure/module/dependent/image/upload';
import {
    TDWActionType,
    TDWModuleType,
    TDWOperationType,
} from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { IDynamicService } from '@src/slide/infrastructure/module/independent/dynamic-loader/dynamic-service';
import { EventEmitter as EventBus } from '@src/slide/infrastructure/module/independent/event-emitter';
import { IEventEmitter } from '@src/slide/infrastructure/module/independent/event-emitter/event-emitter.interface';
import eventBus, { EventKeys } from '@src/slide/infrastructure/module/independent/event-emitter/instance';
import userLocalStorage, { LocalStorageKeys } from '@src/slide/infrastructure/module/independent/local-storage';
import { PadType } from '@tencent/docs-mime-types';
import Loading from '@tencent/dui/lib/components/Loading';
import Modal from '@tencent/dui/lib/components/Modal';
import Snackbar from '@tencent/dui/lib/components/Snackbar';
import { network } from '@tencent/netcheck';
import { hasAttachmentOrMediaExceedsLimit } from '@utils/attachment';
import { handleIndentBtnDisableState } from '@utils/indent/indent-menu-state';
import * as mobx from 'mobx';
import { IReactionDisposer } from 'mobx';
import { isBVisitC } from 'utils';
import { IRightSideBarService } from '../right-side-bar-service/core/interface';
import { IToolbarStateManager } from '../toolbar-state-manager/core/toolbar-state-manager.interface';

export default class MenuManager implements IMenuManager {
    // =========== observable states ===========
    @mobx.observable
    public asyncMenuItemReady = false;
    /**
     * 菜单是否展示(包括顶部菜单和右键菜单)
     */
    @mobx.observable
    public isMenuShown = false;
    @mobx.observable
    public hideAllMenuNum = 0;
    /**
     * 是否正在取色
     */
    @mobx.observable
    public isColorPicking = false;
    /**
     * 是否展示修改比例的菜单
     */
    @mobx.observable
    public showRatioViewAction = 0;
    /**
     * dropdown 是否展示
     */
    @mobx.observable
    public isDropdownShown = false;

    public selectedMgrRef: SelectedEleManager;
    public selectionServiceRef: ISelectionService;
    public uiDataServiceRef: IUiDataService;
    public userPriviledgeServiceRef: IUserPriviledgeService;
    public mergeMenuValuesCacheMap = new WeakMap();
    public paragraphManager: IParagraphManager;
    public rightSideBarManager?: IRightSideBarManager;
    public themeColorManager?: IThemeColorManager;
    public guidesManager?: IGuidesManager;
    public snapLineService?: ISnapLineService;
    public textRulerManager?: ITextRulerManager;
    public gridLineManager?: IGridLineManager;
    public insertTableRowColManager?: IInsertTableRowColManager;
    public importOnlineFileManager?: IDynamicService<IImportOnlineFileManager>;
    public historyManager?: IHistoryManager;
    public exportPreferenceService: IExportPreferenceService;
    public fontManager?: IFontManager;
    public toolbarStateManager?: IToolbarStateManager;
    public rightSideBarService?: IRightSideBarService;
    private masterLayoutEditServiceRef?: IMasterLayoutEditService;
    private _event: IEventEmitter<MenuManagerEventsMap>;
    private refreshReaction: IReactionDisposer;
    private disableItemIdsCache: Array<{ id: string }> | null;
    private sectionManager?: ISectionManager;
    private exportImageManager?: ExportImageManager;

    public constructor(props: {
        selectionService?: ISelectionService,
        uiDataService?: IUiDataService,
    }) {
        this._event = new EventBus<MenuManagerEventsMap>(); // 跟菜单相关的逻辑可以用这个eventBus

        this.observeModelMergeValuesChange();
        this.addHistoryManagerEventListener();

        if (props.selectionService) {
            this.setSelectionServiceDelegate(props.selectionService);
        }

        if (props.uiDataService) {
            this.setUiDataServiceDelegate(props.uiDataService);
        }
    }

    public setSelectionServiceDelegate(selectionService: ISelectionService): void {
        if (this.selectionServiceRef) return;
        this.selectionServiceRef = selectionService;
        this.selectedMgrRef = selectionService.selectedElements;
    }

    public setUiDataServiceDelegate(uiDataService: IUiDataService): void {
        if (this.uiDataServiceRef) return;
        this.uiDataServiceRef = uiDataService;
    }

    public setSectionManagerDelegate(sectionManager: ISectionManager): void {
        if (this.sectionManager) return;
        this.sectionManager = sectionManager;
    }

    public setExportImageManagerDelegate(exportImageManager: ExportImageManager) {
        if (!this.exportImageManager) {
            this.exportImageManager = exportImageManager;
        }
    }

    public getSectionManagerDelegate(): ISectionManager | undefined {
        return this.sectionManager;
    }

    public setUserPriviledgeServiceDelegate(userPriviledgeService: IUserPriviledgeService): void {
        if (this.userPriviledgeServiceRef) return;
        this.userPriviledgeServiceRef = userPriviledgeService;
    }

    public setMasterLayoutEditServiceDelegate(masterLayoutEditService: IMasterLayoutEditService): void {
        if (this.masterLayoutEditServiceRef) return;
        this.masterLayoutEditServiceRef = masterLayoutEditService;
    }

    public setParagraphManager(paragraphManager: IParagraphManager): void {
        if (this.paragraphManager) return;
        this.paragraphManager = paragraphManager;
    }

    public setRightSideBarManagerDelegate = (rightSideBarManager?: IRightSideBarManager) => {
        this.rightSideBarManager = rightSideBarManager;
    };

    public setRightSideBarServiceDelegate = (rightSideBarService?: IRightSideBarService) => {
        this.rightSideBarService = rightSideBarService;
    };

    public setThemeColorManager = (themeColorManager: IThemeColorManager) => {
        this.themeColorManager = themeColorManager;
    };

    public setGuidesManager = (guidesManager: IGuidesManager) => {
        this.guidesManager = guidesManager;
    };

    public setSnapLineService = (snapLineService: ISnapLineService) => {
        this.snapLineService = snapLineService;
    };

    public setTextRulerManager = (textRulerManager: ITextRulerManager) => {
        this.textRulerManager = textRulerManager;
    };

    public setGridLineManager = (gridLineManager: IGridLineManager) => {
        this.gridLineManager = gridLineManager;
    };

    public setInsertTableRowColManager = (insertTableRowColManager: IInsertTableRowColManager) => {
        this.insertTableRowColManager = insertTableRowColManager;
    };

    public setToolbarStateManagerDelegate(toolbarStateManager: IToolbarStateManager) {
        this.toolbarStateManager = toolbarStateManager;
    }

    public hideAllMenu(): void {
        this.hideAllMenuNum += 1; // 一旦值变更，就触发关闭所有菜单操作
    }

    // 监听组合、多选图形、table的发布的重刷缓存（因为这些的菜单属性是聚合所有子元素的属性而来，所以默认缓存，只有在部分时机重刷）
    observeModelMergeValuesChange() {
        this.event.on(ModelMenuRefreshEventsKeys.REFRESH_MENU_VALUES_VALUES, (model) => {
            this.mergeMenuValuesCacheMap.delete(model);
            this.mergeMenuValuesCacheMap.set(model, getMenuValues(model));
        });
    }

    public addHistoryManagerEventListener() {
        // 查看修订记录时屏蔽播放
        this.historyManager?.on('show', () => {
            const idx = ViewerEnableItems.indexOf(ActionType.SLIDE_PLAY);
            if (idx === -1) return;

            ViewerEnableItems.splice(idx, 1);
        });
        this.historyManager?.on('hide', () => {
            const idx = ViewerEnableItems.indexOf(ActionType.SLIDE_PLAY);
            if (idx >= 0) return;

            ViewerEnableItems.push(ActionType.SLIDE_PLAY);
        });
    }

    public get event(): IEventEmitter<MenuManagerEventsMap> {
        return this._event;
    }

    public topMenu(): IMenuItems {
        return this.menu(MenuType.TOP_MENU);
    }

    public toolbarMenu(selectedModel?: SelectedModelType): IMenuItems {
        return this.menu(MenuType.TOOLBAR, selectedModel);
    }

    public propertyMenu(selectedModel?: SelectedModelType): IMenuItems {
        return this.menu(MenuType.PROPERTY_BAR, selectedModel);
    }

    public stylePanelMenu(): IMenuItems {
        return this.menu(MenuType.STYLE_PANEL);
    }

    public quickSetMenu(): IMenuItems {
        return this.menu(MenuType.QUICK_SETTING);
    }

    /**
     * 返回右键菜单项 & callback
     * @param type  Boolean true： slide  false：elements
     * @returns {*}
     */
    rightMenu(type?: boolean) {
        return type ? this.rightMenu4Slide() : this.menu(MenuType.POP_MENU);
    }

    /**
     * 判断组合按钮是否需要被diabled
     */
    isGroupItemNeedDisabled() {
        // 单选时（非组合元素），组合按钮被disabled
        if (!(this.selectionServiceRef.getSelectedModel() instanceof MultiplyModel)
            && !(this.selectionServiceRef.getSelectedModel() instanceof GroupModel)) {
            return true;
        }
        return false;
    }

    public showRatioView() {
        this.showRatioViewAction += 1;
    }


    public disableItemIds(): Array<{ id: string }> | null {
        if (!this.disableItemIdsCache) {
            // 没有缓存则计算并缓存，并在本事件轮询结尾将缓存清除，避免更新不及时
            this.disableItemIdsCache = this.getDisableItemIdsNoCache();
            Promise.resolve().then(() => {
                this.disableItemIdsCache = null;
            });
        }
        return this.disableItemIdsCache;
    }

    // eslint-disable-next-line complexity
    public getDisableItemIdsNoCache() {
        let disableData: Array<any> = [
            { id: ActionType.NO_AVAILABLE_ADDON },
            { id: ActionType.RECOMMEND_ADDON },
            { id: ActionType.INSTALLED_ADDON },
            { id: ActionType.FONT_HANDLER },
            { id: ActionType.COLOR_HANDLER },
            { id: ActionType.PIC_HANDLER },
        ];

        if (this.userPriviledgeServiceRef.pptEditorState === PPTEditorStateType.EDITABLE) { // 编辑态
            disableData = this._disableInEditing(disableData);
        } else { // 查看状态
            disableData = this._disableInViewing(disableData);
        }

        if (this.masterLayoutEditServiceRef?.isMasterEditType) {
            disableData = this._disableInMaster(disableData);
        }

        // 离线需置灰
        if (!network.isOnline) {
            disableData = this._disableWhenOffline(disableData);
        }

        let lock = false;
        // 锁页特殊处理:基于此前的状态做一些隐藏
        if (this.selectionServiceRef.currentSlideIndex >= 0) {
            const lockManager = OnlineEditServices.CooperationLockManager();
            const lockInfo = lockManager?.getLockInfoByIndex(
                this.selectionServiceRef.currentSlideIndex,
                this.selectionServiceRef.currentSlideType,
            );
            const isLocked = lockInfo && !lockInfo.user.isSelf;
            const isPreload = this.selectionServiceRef.currentSlide?.preload;
            if (isLocked || isPreload) {
                lock = true;
                disableData = disableData.concat(LockDisableItems);
            }
        }

        // 已经在幻灯片中使用的版式部分选项不可用
        // 若选中的是母版，几乎都不可用
        if (this.selectionServiceRef.selectedSlides.selectedArray?.some(i => i.isMaster)) {
            disableData = disableData.concat(masterDisabledItem);
        }

        if (this.selectionServiceRef.selectedSlides.selectedArray?.some(i => i.isLayout)) {
            const layoutIds = this.selectionServiceRef.selectedSlides.selectedArray.map(i => i.id);
            if (this.uiDataServiceRef.slideModelList.some(i => layoutIds.includes(i.layoutId))) {
                disableData = disableData.concat(usedLayoutDisabledItem);
            }
        }

        // 不是owner的时候，不提供水印修改能力
        if (!SlideDataServices.DocInfoManager()?.isOwner) {
            disableData = disableData.concat(notOwnerDisableItems);
        }

        // 在内存中没有复制的元素时，粘贴按钮为disable
        if (this.userPriviledgeServiceRef.pptEditorState !== PPTEditorStateType.EDITABLE || lock) {
            // disable 粘贴
            disableData = disableData.concat(NoPasteMemoryCacheDisableItems);
        }

        // undo redo
        if (!SlideDataServices.SDKDataServices.CommandManager()?.canUndo) {
            disableData = disableData.concat(NoUndoDisableItems);
        }
        if (!SlideDataServices.SDKDataServices.CommandManager()?.canRedo) {
            disableData = disableData.concat(NoRedoDisableItems);
        }

        if (this.isGroupItemNeedDisabled()) {
            disableData = disableData.concat([
                { id: ActionType.GROUP, title: i18n.t('组合') },
            ]);
        }

        disableData = handleIndentBtnDisableState(disableData, this.selectionServiceRef.getSelectedModel());
        disableData = disableData.concat(this.getGroupItemsNeedDisabled());
        disableData = disableData.concat(this.getDistributeNeedDisabled());
        return disableData;
    }

    /**
     * 获取是否禁用横向/纵向分布
     */
    getDistributeNeedDisabled() {
        let disableItems: Array<any> = [
        ];
        if (this.selectionServiceRef.getSelectedModel() instanceof MultiplyModel) {
            // 多选两个元素时，禁用横向/纵向分布，一个和两个以上不禁用
            if (this.selectedMgrRef.selectedArray?.length === 2) {
                disableItems = disableItems.concat(TwoElementDistributeDisableItems);
            }
        }
        return disableItems;
    }

    /**
     * 获取需要被disabled的组合按钮
     */
    getGroupItemsNeedDisabled() {
        let disableItems = [
            { id: ActionType.GROUP, title: i18n.t('组合') },
            { id: ActionType.ADDGROUP, title: i18n.t('组合') },
            { id: ActionType.REMOVEGROUP, title: i18n.t('取消组合') },
        ];
        if (this.selectionServiceRef.getSelectedModel() instanceof GroupModel) {
            disableItems = [{ id: ActionType.ADDGROUP, title: i18n.t('组合') }];
        } else if (this.selectionServiceRef.getSelectedModel() instanceof MultiplyModel) {
            // 可以取消组合
            if (canUnGroup(this.selectedMgrRef.selectedArray)) {
                disableItems = disableItems.filter(item => item.id === ActionType.ADDGROUP);
            }
            // 可以组合
            if (isElementsCanGroup(this.selectedMgrRef.selectedArray)) {
                disableItems = disableItems.filter(item => item.id === ActionType.REMOVEGROUP);
            }
        }
        return disableItems;
    }

    public _disableInViewing(disableData) {
        let result = disableData;
        result = disableData.concat(Object.keys(ActionType).map(key => ({ id: ActionType[key] })))
            .concat(ViewerDisableItems);
        const enableItems = [...ViewerEnableItems];
        this.disableInViewForExpoprtAndCopy(enableItems);
        if (this.userPriviledgeServiceRef.pptEditorState === PPTEditorStateType.COPYABLE) {
            if (!enableItems.find(enableItem => enableItem === ActionType.COPY)) {
                enableItems.push(ActionType.COPY);
                enableItems.push(ActionType.DOWNLOAD_PICTURE);
            }
        }
        if (SlideDataServices.DocInfoManager()?.isOwner && isLicenseValid()) { // 协同编辑态，所有人是自己，不隐藏修订记录，浏览记录和转让文档所有权
            enableItems.push(ActionType.REVISION_RECORD);
            enableItems.push(ActionType.BROWSE_RECORD);
            enableItems.push(ActionType.TRANSFER_OWNERSHIP);
            // 所有人是自己，且文档处于被举报状态，显示文档申诉入口
            if (SlideDataServices.DocInfoManager()?.dirty === 1) {
                enableItems.push(ActionType.APPEAL);
            }
        }
        this.changeOwnerSettingInView(enableItems);
        this.disableInViewForComment(enableItems);
        result = result.filter(item => !enableItems.find(enableItem => enableItem === item.id));
        return result;
    }

    public disableInViewForExpoprtAndCopy(enableItems) {
        const exportable = SlideDataServices.PrivilegeManager()?.exportable;
        if (exportable) {
            const actionTypesToAdd = [
                ActionType.EXPORT,
                ActionType.NATIVE_PPT,
                ActionType.EXPORT_PDF,
                `${ActionType.EXPORT_PDF}-toolbar`,
            ];
            actionTypesToAdd.forEach((actionType) => {
                if (!enableItems.includes(actionType)) {
                    enableItems.push(actionType);
                }
            });
            if (!enableItems.find(enableItem => enableItem === ActionType.EXPORT_IMAGE)
                && this.selectionServiceRef.slides.length) {
                enableItems.push(ActionType.EXPORT_IMAGE);
            }
        }
        const canGenerateCopies = SlideDataServices.PrivilegeManager()?.canGenerateCopies;
        if (canGenerateCopies) {
            if (!enableItems.find(enableItem => enableItem === ActionType.GENERATE_COPIES)) {
                enableItems.push(ActionType.GENERATE_COPIES);
            }
            if (!enableItems.find(enableItem => enableItem === ActionType.SAVE_TEMP)) {
                enableItems.push(ActionType.SAVE_TEMP);
            }
        }
    }

    public disableInViewForComment(enableItems) {
        const isLocalEditReadonly = ENV.IS_PC_LOCAL_EDIT
            && this.userPriviledgeServiceRef.pptEditorState !== PPTEditorStateType.EDITABLE;
        if (this.historyManager?.isShown() || isLocalEditReadonly) {
            const commentIndex = enableItems.indexOf(ActionType.INSERT_COMMENT);
            enableItems.splice(commentIndex, 1);
            return;
        }
        // 查看态时，批注按钮可用
        enableItems.push(...CommentDisableItems);
    }

    _disableInMaster(disableData) {
        const disableInMaster = [ActionType.INSERT_ANIMATION, ActionType.REVISION_RECORD];
        disableInMaster.forEach(id => !disableData.find(disableId => id === disableId)
            && disableData.push({ id }));
        return disableData;
    }

    // eslint-disable-next-line complexity
    public _disableInEditing(disableData) {
        let result = disableData;
        let model: SelectedModelType = null;
        if (this.selectionServiceRef.lastMouseDownRegion === RegionType.NOTE) {
            model = (this.selectionServiceRef.currentSlide?.noteData) || this.selectionServiceRef.getSelectedModel();
        } else {
            model = this.selectionServiceRef.selectedSlides.length > 0
                && this.selectionServiceRef.getSelectedModel()?.type === UIModelType.EMPTY
                ? this.selectionServiceRef.selectedSlides.selectedArray[0]
                : this.selectionServiceRef.getSelectedModel();
        }
        model && (result = result.concat(getDisableMenuItems(model, {
            editorInstanceService: this.getAppServices().viewableServiceLayer.editorInstanceService,
        })) || []);
        if (!SlideDataServices.DocInfoManager()?.isOwner) { // 协同编辑态
            result = result.concat(CollaboratorSelectDisableItems);
        }
        if (!this.selectionServiceRef.slides.length) result.push({ id: ActionType.EXPORT_IMAGE });
        // 编辑态中复制权限为false，需要置灰的菜单, 主要是防止文本信息被复制。
        if (!SlideDataServices.PrivilegeManager()?.copyable
            && [RegionType.EDITOR, RegionType.NOTE, RegionType.SLIDELIST]
                .includes(this.selectionServiceRef.lastMouseDownRegion)
        ) {
            result.push({ id: ActionType.CUT }, { id: ActionType.COPY });
        }
        return result;
    }

    // 右键点击数据上报
    rightClickTWD() {
        tdw({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.INSERT_SLIDE_ENTRY,
            action: TDWActionType.INSERT_SLIDE_ENTRY_CLICK,
        });
    }

    // 选中左侧幻灯片列表时的右键菜单
    public rightMenu4Slide() {
        this.rightClickTWD();
        const slide = this.selectionServiceRef.currentSlide;
        if (!slide) { // TODO 理论上不应该出现这种情况，但是有crash，先保护一下
            return;
        }
        let items = getMenuItems(MenuType.POP_MENU, slide);
        if (this.userPriviledgeServiceRef.pptEditorState >= PPTEditorStateType.COPYABLE) {
            const enableItems = ViewerEnableItems;
            items = items.filter(item => (item.id === ActionType.COPY
                ? item
                : enableItems.find(enableItem => enableItem === item.id)));
        }
        return {
            type: slide.type,
            items,
            values: getMenuValues(slide),
            // eslint-disable-next-line max-len
            callback: (menuType, actionType, values, extraOption) => handleCommonMenuEvent(this, { menuType, actionType, values, extraOption }),
        };
    }

    public rightMenu4Layout() {
        const layout = this.selectionServiceRef.currentSlide;
        if (!layout) {
            return;
        }
        const items = getMenuItems(MenuType.POP_MENU, layout);
        return {
            type: layout.type,
            items,
            values: getMenuValues(layout),
            // eslint-disable-next-line max-len
            callback: (menuType, actionType, values, extraOption) => handleCommonMenuEvent(this, { menuType, actionType, values, extraOption }),
        };
    }

    public getRightMenuFromModel(model) {
        this.rightClickTWD();
        let items = getMenuItems(MenuType.POP_MENU, model);
        if (this.userPriviledgeServiceRef.pptEditorState >= PPTEditorStateType.COPYABLE) {
            const enableItems = ViewerEnableItems;
            items = items.filter(item => enableItems.find(enableItem => enableItem === item.id));
        }
        return {
            type: model.type,
            items,
            values: getMenuValues(model),
            // eslint-disable-next-line max-len
            callback: (menuType, actionType, values, extraOption) => handleCommonMenuEvent(this, { menuType, actionType, values, extraOption }),
        };
    }

    public getRightMenuFromGuides(model) {
        this.rightClickTWD();
        const items = getMenuItems(MenuType.POP_MENU, model);
        // todo: 查看态
        return {
            type: model.type,
            items,
            values: {},
            // eslint-disable-next-line max-len
            callback: (menuType, actionType, values, extraOption) => handleCommonMenuEvent(this, { menuType, actionType, values, extraOption }),
        };
    }

    public getRightMenuFromTheme(model) {
        this.rightClickTWD();
        // todo: 查看态
        const items = getMenuItems(MenuType.POP_MENU, model);
        return {
            type: UIModelType.THEME,
            items,
            values: {},
            // eslint-disable-next-line max-len
            callback: (menuType, actionType, values, extraOption) => handleCommonMenuEvent(this, { menuType, actionType, values, extraOption }),
        };
    }

    // 选中左侧幻灯片列表间隙时的右键菜单
    rightMenu4SlideGap(gapIndex, isFromMasterLayout?: boolean) {
        const gap = new GapModel({
            gapIndex,
            isFromMasterLayout,
        });
        return this.getRightMenuFromModel(gap);
    }

    /**
     * @param {number} sectionIndex
     */
    rightMenu4Section(sectionIndex) {
        const section = new SectionModel({
            sectionIndex,
        });
        return this.getRightMenuFromModel(section);
    }

    /**
     * Element 元素 菜单    （目前：slide 和 gap 菜单处理没有在这里.）
     * @param type
     * @returns {{values: (*|*|{}|Array), callback: callback, type: *, items: ({}|*)}}
     */
    public menu(type, selectedModel?: SelectedModelType): IMenuItems {
        const model = selectedModel ?? this.selectionServiceRef.getSelectedModel();

        if (!model) {
            return {
                type: '',
                items: [],
                values: [],
                callback: () => {},
            };
        }

        let values = getMenuValues(model);
        const items = getMenuItems(type, model);
        const menuDataWorkerManager = this.getAppServices().editableServiceLayer?.menuDataWorkerManager;
        // 外部manager参与菜单元素的处理逻辑。
        menuDataWorkerManager?.processItemData(
            items,
            type,
            this.toolbarStateManager?.getToolbarMode(),
        );
        values = menuDataWorkerManager?.processMenuItemValues(values, type) || values;
        return {
            type: model.type,
            items,
            values,
            callback: (menuType, actionType, values, extraOption?) => {
                const hasExecuted = handleModelMenuEvent(model, { menuType, actionType, values, extraOption });
                if (!hasExecuted) {
                    return handleCommonMenuEvent(this, { menuType, actionType, values, extraOption });
                }
                return true;
            },
        };
    }

    _actionBrowseRecord = () => {
        tdw({
            opername: TDWOperationType.DOC_EDITOR_TOPBAR_PC,
            module: TDWModuleType.MORE_MENU,
            action: TDWActionType.BROWSING_HISTORY,
        });
        this.getAppServices().viewableServiceLayer.extensionService?.getCallBackAdapter()?.onBrowserReadRecord?.();
        return true;
    };

    public actionTextFormat = (): void => {
        this.rightSideBarService?.hide();                                    // 关闭权限侧边栏
        // 打开格式设置侧边栏，默认展开文字项
        this.rightSideBarManager?.setPropertyEditorShowAction(PropertyEditorShowAction.TEXT_ADJUST_TOGGLE);
    };

    _actionRevisionRecord = (options?: { activeId?: string, type?: string }) => {
        tdw({
            opername: TDWOperationType.DOC_EDITOR_TOPBAR_PC,
            module: TDWModuleType.MORE_MENU,
            action: TDWActionType.REVISION_HISTORY,
        });
        this.historyManager?.show({ showTab: !IS_ENTERPRISE, activeId: options?.activeId, type: options?.type });
        return true;
    };


    _actionExitDocument = () => {
        tdw({
            opername: TDWOperationType.DOC_EDITOR_TOPBAR_PC,
            module: TDWModuleType.MORE_MENU,
            action: TDWActionType.EXIT_DOCUMENT,
        });
        this.getAppServices().viewableServiceLayer.extensionService?.getCallBackAdapter()?.exitCurrentDocument?.();
        return true;
    };

    public actionNativePPT = () => this._actionNativePPT();

    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    _actionNativePPT = () => {
        eventBus.emit(EventKeys.START_EXPORT);

        tdw({
            opername: TDWOperationType.DOC_EDITOR_TOPBAR_PC,
            module: TDWModuleType.MORE_MENU,
            action: TDWActionType.EXPORT,
            ver11: 1,
        });

        if (IS_ENTERPRISE) {
            // 企微PC客户端使用a标签进行下载
            return this.exportNativePPTByAnchor();
        }

        tdw({
            opername: TDWOperationType.DOC_WORD_EDITOR,
            module: TDWModuleType.EXPORT,
            action: TDWActionType.ENTRANCE_CLICK,
        });

        this._invokeExportPreferenceDialog(async (_, fontOptions) => {
            const downloadExtension = await getDownloadExtension();
            downloadExtension.export({
                padType: PadType.Slide,
                params: {
                    docId: SlideDataServices.DocInfoManager()?.globalPadId ?? '',
                },
                allowDownloadInElectronApp: true,
                hasAttachments: hasAttachmentOrMediaExceedsLimit(this.uiDataServiceRef.presentation).hasAttachment,
                fontOptions: {
                    hasWebFonts: !!fontOptions?.exportFont,
                    hasTencentSans: fontOptions?.hasTencentSans,
                    hasVipFonts: fontOptions?.hasVipFonts,
                },
                meta: {
                    title: SlideDataServices.SlideTitleManager()?.title ?? '',
                    url: window.location.href,
                },
            });
        }, true);
    };

    exportNativePPTByAnchor = () => {
        function download(fileUrl) {
            const a = document.createElement('a');
            a.setAttribute('download', '');
            a.setAttribute('href', fileUrl);
            a.click();
        }
        this.getAppServices().viewableServiceLayer.exportManager.promise().then((exportManager) => {
            exportManager.exportSlideFile(
                SlideDataServices.DocInfoManager()?.globalPadId || '',
                {
                    successCallback: () => {
                        // TODO 看起来这的代码已经不执行先删除了，如果企微有bug需要重新梳理下
                    },
                },
            );
        });
    };

    _actionPerformance = () => {
        userLocalStorage.setItem(LocalStorageKeys.SAVED_SHOW, true);
        PerformanceStats.showPerformanceStats();
        return true;
    };

    _actionLink = () => {
        if (!this.getAppServices().viewableServiceLayer.editorInstanceService.checkEditorIsEditing()) {
            const model = this.selectionServiceRef.getSelectedModel();
            if (model?.type === UIModelType.EMPTY) { // 无选中，插入文本框
                this.getAppServices().viewableServiceLayer.linkManager.insertTextWithLink();
            } else {
                this.event.emit(MenuManagerEventsKeys.ENTER_LINK_EDIT);
            }
        }
        return true;
    };

    actionSetWatermark = () => {
        // 调用组件接口，显示水印组件
        this.getAppServices().viewableServiceLayer.watermarkManager.promise().then((watermarkManager) => {
            watermarkManager.showDialog();
        });
    };

    exportPDF = (needReport?: boolean, exportOptions?: ExportPDFOptions) => {
        eventBus.emit(EventKeys.START_EXPORT);

        if (IS_ENTERPRISE || isBVisitC()) {
            this._getExportPdfManager().then((ExportPDFManager) => {
                ExportPDFManager.getInstance().localExport();
            });
            return;
        }
        if (browser.isWxMiniProgram) {
            this._getExportPdfManager().then((ExportPDFManager) => {
                ExportPDFManager.getInstance().onlineExport();
            });
        } else {
            if (this.uiDataServiceRef.presentation.children.every(slide => !slide.isShowInPlay)) {
                Modal.confirm({
                    title: i18n.t('导出PDF失败'),
                    content: i18n.t('所有页面被隐藏无法导出，请重新选择后重试。'),
                    okText: i18n.t('我知道了'),
                    cancelText: null,
                });
                return;
            }
            this._invokeExportPreferenceDialog(async (attachmentOptions, fontOptions) => {
                const exportPreferenceDialog = await this._getExportPreferenceDialog();
                exportPreferenceDialog.show({
                    onConfigChange: this._onExportDialogConfigChange,
                    onExport: (options) => {
                        this._onExportDialogExportPdf(options, needReport, exportOptions);
                    },
                    attachmentOptions,
                    fontOptions,
                });
            }, false);
        }
    };

    /**
     * 生成长图能力，已经抽离到一个单一的文件中
     * @returns
     */
    public exportImage = async (options: ICustomOptionsProps = {}) => {
        eventBus.emit(EventKeys.START_EXPORT);

        if (this.uiDataServiceRef.presentation.children.every(slide => !slide.isShowInPlay)) {
            Modal.confirm({
                title: i18n.t('生成图片失败'),
                content: i18n.t('所有页面被隐藏无法生成图片，请重新选择后重试。'),
                okText: i18n.t('我知道了'),
                cancelText: null,
            });
            return;
        }
        await this.exportImageManager?.exportImage(options);
    } ;

    /**
     * 编辑Latex公式
     */
    // eslint-disable-next-line complexity
    public actionReplaceLatex = async (type?, id = ActionType.REPLACE_WITH_LATEX) => {
        if (!network.isOnline) {
            this.getAppServices().viewableServiceLayer.addonManager.event.emit(AddonManagerEventsKeys.ERROR_NETWORK);
            return;
        }

        // 移动端禁止编辑公式
        if (browser.isMobile) {
            return;
        }

        // 获取当前选中公式图片数据
        const selectedModel = this.selectionServiceRef.getSelectedModel();

        // 编辑latex公式图片
        if (id === ActionType.REPLACE_WITH_LATEX) {
            // 编辑的公式图片一定是image类型
            if (selectedModel?.type !== UIModelType.IMAGE) return;
            // 调用插件编辑接口
            (this.getAppServices().viewableServiceLayer.addonManager.addonHandler as IAddonHandler)?.emitMessageToAddon(
                '$onToolbarClick',
                {
                    action: 'editAddon',
                    data: (selectedModel as IPictureModel)?.props?.addon,
                },
                (selectedModel as IPictureModel)?.props.addon?.aid ?? '',
            );

            // 上报：点击编辑公式按钮
            tdw({
                opername: TDWOperationType.DOC_FORMULA,
                module: TDWModuleType.FORMULA_RE_EDITED,
                action: TDWActionType.FORMULA_CLICK,
            });
        }

        // OCR识别公式，再编辑
        if (id === ActionType.OCR_WITH_LATEX) {
            // 导入的公式是shape类型，和office一致的
            if (selectedModel?.type !== UIModelType.SHAPE) return;
            const serviceLayer = this.getAppServices().editableServiceLayer;
            if (!serviceLayer) return;
            // 开始识别，弹出loading
            const loading = Loading.show({ tip: i18n.t('正在识别公式...') });
            const image = (selectedModel as IPictureModel)?.props.style.fillBackground?.image;
            if (!image) return;

            try {
                const dataURL = await imageToBase64(image.src) as string;
                const { formulaOCR } = await serviceLayer.formulaOcrManager.promise();
                const formulaText = await formulaOCR(dataURL);

                // 关闭loading
                loading.close();

                if (typeof formulaText === 'string' && formulaText) {
                    // 打开公式编辑面板
                    (this.getAppServices().viewableServiceLayer.addonManager.addonHandler as IAddonHandler)
                        .openFormulaDialog(formulaText);
                } else {
                    // 提示识别失败
                    CommonTips.getInstance().show({
                        message: i18n.t('无法识别公式，请重试。'),
                        autoClose: true,
                        block: false,
                    });
                }
            } catch (err) {
                // 关闭loading
                loading.close();
                // 提示识别失败
                CommonTips.getInstance().show({
                    message: i18n.t('无法识别公式，请重试。'),
                    autoClose: true,
                    block: false,
                });
            }
        }
    };

    /**
     * 使用插件SDK能力调用插件插入接口
     * @param menuId
     */
    addonInsertHandler = (menuId) => {
        const addonId = this.getAddonID(menuId);
        // 点击插件菜单列表,事件抛给SDK去做
        this.getAppServices().viewableServiceLayer.addonManager.addonHandler.executeMenuAction(addonId, menuId);
    };

    /**
     * 获取addonId
     * @return {String} addonId
     * @param menuId
     */
    public getAddonID = menuId => menuId.substring(0, menuId.indexOf('_'));

    // eslint-disable-next-line no-unused-vars
    report(type, id) {
        switch (id) {
            case ActionType.ADDGROUP:
                this._reportAddGroup(type);
                break;
            case ActionType.REMOVEGROUP:
                this._reportRemoveGroup(type);
                break;
        }
    }

    _reportRemoveGroup(type) {
        tdw({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.PPT_PC_EDIT_COMBINATION,
            action: TDWActionType.REMOVE_COMBINATION_TOTAL_UV,
        });
        switch (type) {
            case MenuType.TOOLBAR: // 工具栏
                tdw({
                    opername: TDWOperationType.DOC_PPT,
                    module: TDWModuleType.PPT_PC_EDIT_COMBINATION,
                    action: TDWActionType.REMOVE_COMBINATION_TOOL,
                });
                break;
            case MenuType.TOP_MENU: // 菜单栏
                tdw({
                    opername: TDWOperationType.DOC_PPT,
                    module: TDWModuleType.PPT_PC_EDIT_COMBINATION,
                    action: TDWActionType.REMOVE_COMBINATION_COM_MENU,
                });
                break;
            case MenuType.POP_MENU: // 右键
                tdw({
                    opername: TDWOperationType.DOC_PPT,
                    module: TDWModuleType.PPT_PC_EDIT_COMBINATION,
                    action: TDWActionType.REMOVE_COMBINATION_COM_CLICK,
                });
                break;
        }
    }

    _reportAddGroup(type) {
        tdw({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.PPT_PC_EDIT_COMBINATION,
            action: TDWActionType.COMBINATION_TOTAL_UV,
        });
        switch (type) {
            case MenuType.TOOLBAR: // 工具栏
                tdw({
                    opername: TDWOperationType.DOC_PPT,
                    module: TDWModuleType.PPT_PC_EDIT_COMBINATION,
                    action: TDWActionType.COMBINATION_TOOL,
                });
                break;
            case MenuType.TOP_MENU: // 菜单栏
                tdw({
                    opername: TDWOperationType.DOC_PPT,
                    module: TDWModuleType.PPT_PC_EDIT_COMBINATION,
                    action: TDWActionType.COMBINATION_MENU,
                });
                break;
            case MenuType.POP_MENU: // 右键
                tdw({
                    opername: TDWOperationType.DOC_PPT,
                    module: TDWModuleType.PPT_PC_EDIT_COMBINATION,
                    action: TDWActionType.COMBINATION_CLICK,
                });
                break;
        }
    }

    async _getExportPdfManager(needReport = true) {
        if (needReport) {
            tdw({
                opername: TDWOperationType.DOC_EDITOR_TOPBAR_PC,
                module: TDWModuleType.MORE_MENU,
                action: TDWActionType.EXPORT,
                ver11: 2,
            });
        }
        return (await import('@tencent/docs-scenario-components-export-pdf')).ExportPDFManager;
    }

    _invokeExportPreferenceDialog = async (showDialog, shouldCareAttachment) => {
        const attachmentOptions = shouldCareAttachment ? this._getAttachmentOptions() : undefined;
        const fontOptions = await this._getFontOptions();
        window.log?.info(
            'export ppt: attachmentOptions = ',
            attachmentOptions,
            ' fontOptions = ',
            fontOptions,
        );
        showDialog(attachmentOptions, fontOptions);
    };

    _getExportPreferenceDialog = async () => (
        ArkLoader.extensionService.getExtension(EXPORT_PREFERENCE_DIALOG_EXTENSION.name)
    );

    _getAttachmentOptions = () => {
        const {
            hasAttachment,
            isMediaExceedsLimit,
        } = hasAttachmentOrMediaExceedsLimit(this.uiDataServiceRef.presentation);
        if (hasAttachment) {
            return {
                exportAttachment: this.exportPreferenceService.exportAttachmentPreference,
                hasLargeFile: isMediaExceedsLimit,
            };
        }
        return undefined;
    };

    _getFontOptions = async () => {
        const fontUsingStatus = await this.fontManager?.collectFontsUsingStatus();
        if (fontUsingStatus?.hasCustomFonts) {
            return {
                exportFont: this.exportPreferenceService.exportFontPreference ? 'embed' : undefined,
                hasTencentSans: fontUsingStatus.hasTencentSans,
                hasVipFonts: fontUsingStatus.hasVipFonts,
            };
        }
        return undefined;
    };

    _onExportDialogExportPptx = (options, successCallback) => {
        this.getAppServices().viewableServiceLayer.exportManager.promise().then((exportManager) => {
            exportManager.exportSlideFile(
                SlideDataServices.DocInfoManager()?.globalPadId || '',
                {
                    exportWithAttachment: options.attachmentOptions?.exportAttachment ?? false,
                    exportWithFonts: options.fontOptions?.exportFont ?? false,
                    successCallback,
                },
            );
        });
    };

    _onExportDialogExportPdf = (options, needReport = true, exportOptions?: ExportPDFOptions) => {
        // 调用场景化组件，显示导出PDF面板
        this._getExportPdfManager(needReport)
            .then((ExportPDFManager) => {
                let params: any = undefined;
                if (options?.fontOptions?.exportFont) {
                    params = {
                        switches: JSON.stringify({ embedFonts: true }),
                    };
                }
                ExportPDFManager.getInstance().showDialog({
                    ...exportOptions,
                    ...params,
                });
            })
            .catch((err) => {
                window.log.error(`@tencent/docs-scenario-components-export-pdf load error - ${err}`);
                Snackbar.show({
                    message: i18n.t('请求失败，请稍后重试。'),
                    duration: 5000,
                });
            });
    };

    _onExportDialogConfigChange = (options) => {
        if (!options) {
            return;
        }
        if (options.attachmentOptions?.exportAttachment) {
            this.exportPreferenceService.exportAttachmentPreference = true;
        } else {
            this.exportPreferenceService.exportAttachmentPreference = false;
        }
        this.exportPreferenceService.exportFontPreference = Boolean(options.fontOptions?.exportFont);
    };

    private getAppServices(): IEditorAppServices {
        const appService = AppServiceProvider.getInstance().getAppServices() as
            IEditorAppServices;
        return appService;
    }

    private _disableWhenOffline(disableData: Array<any>): Array<any> {
        // 桌面客户端内 dc 组件都有离线资源， 可支持离线生成图片&插入图表
        const disableWhenOffline = [
            ActionType.INTELLIGENT_TOOL,
            ActionType.ADDON,
            ActionType.EXPORT_IMAGE,
            ActionType.OPEN_MUTI_PICTURE_EXPORT,
            ActionType.PDF_TRANSFORM,
            !browser.isTencentDocDesktopApp && ActionType.INSERT_CHART,
            ActionType.DOWNLOAD_ATTACHMENT,
            !ENV.IS_PC_LOCAL_EDIT && ActionType.DOWNLOAD_PICTURE,
            ActionType.OCR_PICTURE,
            ActionType.OCR_WITH_LATEX,
            ActionType.IMPORT_SLIDE,
        ].filter(Boolean);
        disableWhenOffline.forEach(id => !disableData.find(disableId => id === disableId)
            && disableData.push({ id }));
        return disableData;
    }

    private changeOwnerSettingInView(enableItems) {
        // 当创建人的PPTEditorState设置为非编辑态时（COPYABLE/SELECTABLE）,需允许权限设置
        if (!SlideDataServices.DocInfoManager()?.isOwner) return;

        // 置灰版本及编辑记录
        const index = enableItems.indexOf(ActionType.REVISION_RECORD);
        if (index !== -1) {
            enableItems.splice(index, 1);
        }

        // 放开权限设置
        [
            ActionType.PERMISSION_MENU,
            ActionType.PERMISSION_SETTING,
            ActionType.ADVANCED_PERMISSION,
            ActionType.SET_WATER_MARK,
            ActionType.TRANSFER_OWNERSHIP,

        ].forEach(item => enableItems.push(item));
    }
}
